function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4285f4",
  d: "M6 66.0162h14v-34l-20-15v43c0 3.315 2.685 6 6 6z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#34a853",
  d: "M68 66.0162h14c3.315 0 6-2.685 6-6v-43l-20 15z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fbbc04",
  d: "M68 6.0162v26l20-15v-8c0-7.415-8.465-11.65-14.4-7.2z"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ea4335",
  d: "M20 32.0162v-26l24 18 24-18v26l-24 18z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#c5221f",
  d: "M0 9.0162v8l20 15v-26l-5.6-4.2c-5.935-4.45-14.4-.215-14.4 7.2z"
});
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 800,
    viewBox: "-13.2 -16.50405 114.4 99.0243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.456e473acdfa595d925a91ae744cc16d.svg";
export { ForwardRef as ReactComponent };